import { createContext } from "react";
import TokenContextType from "../Types/TokenContextType";

const TokenContext = createContext<TokenContextType>({ token: null, setToken: () => null});
export default TokenContext;
